import { Component } from '@angular/core';

@Component({
  selector: 'prcins-desktop-banner',
  templateUrl: './desktop-banner.component.html',
  styleUrls: ['./desktop-banner.component.css']
})
export class DesktopBannerComponent {}
